define("settings/controllers/overview", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/fetch", "shared/utils/constants/days"], function (_exports, _controller, _object, _service, _tracking, _emberConcurrency, _fetch, _days) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/fetch",0,"shared/utils/constants/days"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let OverviewController = (_class = class OverviewController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "intl", _descriptor5, this);

      _initializerDefineProperty(this, "locale", _descriptor6, this);

      _initializerDefineProperty(this, "payment", _descriptor7, this);

      _initializerDefineProperty(this, "router", _descriptor8, this);

      _initializerDefineProperty(this, "store", _descriptor9, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor10, this);

      _initializerDefineProperty(this, "account", _descriptor11, this);

      _initializerDefineProperty(this, "instagramProfiles", _descriptor12, this);

      _initializerDefineProperty(this, "socialProfiles", _descriptor13, this);

      _initializerDefineProperty(this, "user", _descriptor14, this);

      _defineProperty(this, "queryParams", ['openMobileModal']);
    }

    get canAiCredits() {
      return this.subscriptions.subscriptionPlan?.numberOfAiCredits > 0;
    }

    get days() {
      return (0, _days.default)(this.intl);
    }

    get firstDayWeek() {
      const firstDayIndex = this.user.firstDay || 0;
      const firstDay = this.days.find(day => day.wday == firstDayIndex);
      return firstDay.name;
    }

    get hasCancelledSubscription() {
      return this.subscriptions.hasCurrentSubscription && this.account.hasActiveCancelledSubscription;
    }

    get otp_required() {
      return this.auth.currentUserModel.otp_required_for_login;
    }

    get hasSubscription() {
      return this.subscriptions.hasCurrentSubscription;
    }

    get hasUpcomingDowngrade() {
      return this.subscriptions.hasUpcomingDowngrade;
    }

    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }

    get leaveLaterDescription() {
      return this.isMobileSubscription ? this.intl.t('account.overview.leave_later.description_mobile', {
        platform: this.subscriptions.platform
      }) : this.intl.t('account.overview.leave_later.description');
    }

    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }

    get upcomingSubscriptionPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }

    get allAnalyticsEmails() {
      return this.instagramProfiles.every(profile => profile.analyticsEmail);
    }

    get canEnableTwoFactor() {
      return this.auth.currentAccount.rolloutTwoFactor || this.otp_required;
    }

    logout() {
      this.auth.logout();
    }

    loadPayments() {
      this.payment.retrieve.perform();
    }

    *toggleTwoFactor() {
      if (this.otp_required) {
        yield this.openDisableModal();
      } else {
        this.openModal();
      }
    }

    openModal() {
      this.router.transitionTo('account.overview.two_factor');
    }

    async openDisableModal() {
      await this.dialogManager.confirm(this.intl.t('account.two_factor.disable_two_factor_header'), {
        description: this.intl.t('account.two_factor.disable_two_factor_message'),
        confirmButton: this.intl.t('account.two_factor.disable_two_factor_button')
      });
      await this.disable();
    }

    async disable() {
      try {
        const user = await (0, _fetch.fetch)(`/api/v2/users/disable_two_factor`, {
          method: 'PATCH'
        });
        this.store.pushPayload(user);
        this.alerts.success(this.intl.t('alerts.account.two_factor.disable_complete'));
      } catch (error) {
        this.errors.log(error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "account", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "instagramProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "socialProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "user", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "logout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadPayments", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleTwoFactor", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "toggleTwoFactor"), _class.prototype)), _class);
  _exports.default = OverviewController;
});